import { useState, useEffect } from "react";
import DependentCard from "./DependentCard";
import ViewModal from "./ViewModal";
import AddDependent from "./AddDependent";
import { getDependentsInformation } from "../../../services/rhapsody/ManageDependents";
import { deleteDependentsInformation, viewInformation } from "../../../services/rhapsody/ManageDependents";
import DeleteDependent from "./DeleteDependent";
import { fetchTranslationData } from "../../../services/translation/translation";
import { ServiceTranslation } from "../../../utils/constants";
import AlertDependent from "../../../common/AlertDependent";
import { getLayoutDirection, configureFirstIframe } from "../../../utils/util";
import { Loader } from "../../../common/Loader";
import { isMobileApp } from "../../../utils/util";

const ManageDependentDashboard = () => {
  const [currentPage, setCurrentPage] = useState("home");
  const [depedentList, setDependentList] = useState([]);
  const [show, setShow] = useState(false);
  const [dependent, setDependent] = useState(null); // for view details
  const [deleteDep, setDeleteDependent] = useState(false); // for deleting value
  const [isLoading, setIsLoading] = useState(false);
  const [alertAddDependent, setAlertAddDependent] = useState(false);
  const [deletedData, setDeletedData] = useState(null); //storing deleted data
  const [translationMap, setTranslationMap] = useState(null);
  const [alertAlreadyAdded, setAlertAlreadyAdded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [alertDeceasedPatient, setAlertDeceasedPatient] = useState(false);

  const closeModal = () => {
    setShow(false);
    window.parent.scrollTo(0, 0);
  };
  const handleDeleteDependentData = (depend) => {
    setDeletedData(depend);
  };

  const handleViewDependent = async (depend) => {
    setIsLoading(true);
    const viewDependentMRN = depend;
    try {
      const viewInfoResult = await viewInformation(viewDependentMRN);
      setDependent(viewInfoResult?.data);
    } catch (error) {



      //console.log("No information", error.message);
    }};useEffect(() => {
    if (dependent)
    {
      setIsLoading(false);
      setShow(true);
      window.parent.scrollTo(0, 0);
    }
  }, [dependent]);

  const deleteDependent = async () => {
    setIsLoading(true);
    try {
      window.parent.scrollTo(0, 0);
      const patientId = deletedData;
      await deleteDependentsInformation(patientId);
      const response = await getDependentsInformation();
      setDependentList(response.data);
      setDeleteDependent(false);
      setIsLoading(false);
    } catch (error) {



      // console.log("No deletion ", error.message);
    } finally {setIsLoading(false);}
  };

  useEffect(() => {
    fetchTranslationData(ServiceTranslation.ManageDependents).then((result) => {
      setTranslationMap(result);
    });
    setAlertAlreadyAdded(false);
    setAlertAddDependent(false);
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await getDependentsInformation();
        const safeList = Array.isArray(response.data) ? response.data : [];
        setDependentList(safeList);
        //setDependentList(response.data);
        setIsLoading(false);
      } catch (err) {



        // console.log(err.message);
      }};fetchData();}, []);

  useEffect(() => {
    // console.log("dependent list length ", depedentList?.length);
    let dynamicHeight;
    if (depedentList.length > 0) {
      if (isMobileApp())
      {
        setIsMobile(true);
        dynamicHeight = depedentList.length * 120;
        configureFirstIframe(dynamicHeight);
      } else
      {
        dynamicHeight = depedentList.length * 50;
        configureFirstIframe(dynamicHeight);
      }
    }
  }, [depedentList]);

  if (isLoading)
  {
    return <Loader />;
  }

  return (
    <>
    <div class={` custombody_color ${getLayoutDirection()}`} id="sectionManageDependent">
      {!isLoading && currentPage === "home" &&
        <section
          className="w-100 clearfix ManageDependentMainSection"
          id="CoverPlanActive">
          
            <div className="container customContainer">
              {!isMobile &&
            <div className="Title_Inner_Box">
                <h6 className="MainTitleOne">
                  {translationMap?.manageDependents}
                </h6>
              </div>
            }
              <div className="Alert_Main_Box">
              {alertAddDependent &&
              <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                      <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  onClick={() => setAlertAddDependent(false)}>
                  
                        &times;
                      </button>
                      <div className="Icon_box">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a>
                          <span className="material-symbols-outlined">
                            check_circle
                          </span>
                        </a>
                      </div>
                      <div className="alert_text">
                        <h6>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>{translationMap?.dependentAdded}</a>
                        </h6>
                        <p className="number_txt">
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>{translationMap?.newDependentAdded}</a>
                        </p>
                      </div>
                    </div>
              }
              </div>

              <div className="cover_inner_wrapper">
                <div className="cover_main_box1">
                  <div className="top_title_box">
                    <h6 className="MainTitleOne">
                      {translationMap?.myDependentList}:
                    </h6>
                  </div>
                  {alertAddDependent &&
                <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                      <button
                    type="button"
                    className="close"
                    data-dismiss="alert"
                    onClick={() => setAlertAddDependent(false)}>
                    
                        &times;
                      </button>
                      <div className="Icon_box">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a>
                          <span className="material-symbols-outlined">
                            check_circle
                          </span>
                        </a>
                      </div>
                      <div className="alert_text">
                        <h6>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>{translationMap?.dependentAdded}</a>
                        </h6>
                        <p className="number_txt">
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>{translationMap?.newDependentAdded}</a>
                        </p>
                      </div>
                    </div>
                }
                  {alertAlreadyAdded &&
                <AlertDependent setError={setAlertAddDependent} alert_text={translationMap?.alreadyExist || "Dependent Already Exists"} />
                }

                  {alertDeceasedPatient &&
                <AlertDependent setError={setAlertDeceasedPatient} alert_text={translationMap?.deceasedPatient || "Please do not add deceased patient as dependent"} />
                }

                  {depedentList.length === 0 &&
                <AlertDependent alert_text={translationMap?.nodependentAdded || "No dependent Added please add dependent to see the list"} />
                }
                  <div className="Dependent_list_sub_wrap">
                    {depedentList.map((list, index) => {
                    return (
                      <>
                          <DependentCard
                          key={index}
                          dependentList={list}
                          handleViewDependent={handleViewDependent}
                          setDeleteDependent={setDeleteDependent}
                          handleDeleteDependentData={
                          handleDeleteDependentData
                          }
                          translationMap={translationMap} />
                        
                        </>);

                  })}
                  </div>
                </div>
                {deleteDep &&
              <DeleteDependent
                ondelete={deleteDependent}
                setDeleteDependent={setDeleteDependent}
                translationMap={translationMap} />

              }
                {show &&
              <ViewModal
                dependentList={dependent}
                onClose={closeModal}
                translationMap={translationMap} />

              }
                <div className="cover_main_box2">
                  <div className="inner_content_box">
                    <div className="top_title_box">
                      <h6 className="MainTitleOne">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a>{translationMap?.wantToAddNewDependent}</a>
                      </h6>
                    </div>
                    <div className="btn_box">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                      onClick={() => setCurrentPage("add-dependent")}
                      className="blue_btn_link">

                        {translationMap?.addDependent}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        }
      {currentPage === "add-dependent" &&
        <AddDependent
          setCurrentPage={setCurrentPage}
          setDependentList={setDependentList}
          setAlertAddDependent={setAlertAddDependent}
          depedentList={depedentList}
          setAlertAlreadyAdded={setAlertAlreadyAdded}
          setAlertDeceasedPatient={setAlertDeceasedPatient}
          translationMap={translationMap} />

        }
      </div>
    </>);

};

export default ManageDependentDashboard;